export const NEW_PURCHASE = "NEW_PURCHASE";
export const NEW_PURCHASE_SUCCESS = "NEW_PURCHASE_SUCCESS";
export const ADDITIONAL_PURCHASE = "ADDITIONAL_PURCHASE";
export const ADDITIONAL_PURCHASE_SUCCESS = "ADDITIONAL_PURCHASE_SUCCESS";
export const NEW_FOLIO_SIP = "NEW_FOLIO_SIP";
export const NEW_FOLIO_SIP_SUCCESS = "NEW_FOLIO_SIP_SUCCESS";
export const EXISTING_FOLIO_SIP = "EXISTING_FOLIO_SIP";
export const EXISTING_FOLIO_SIP_SUCCESS = "EXISTING_FOLIO_SIP_SUCCESS";
export const REDEMPTION_TRANSACTION = "REDEMPTION_TRANSACTION";
export const REDEMPTION_TRANSACTION_SUCCESS = "REDEMPTION_TRANSACTION_SUCCESS";
export const SWP_TRANSACTION = "SWP_TRANSACTION";
export const SWP_TRANSACTION_SUCCESS = "SWP_TRANSACTION_SUCCESS";
export const SWITCH_TRANSACTION = "SWITCH_TRANSACTION";
export const SWITCH_TRANSACTION_SUCCESS = "SWITCH_TRANSACTION_SUCCESS";
export const STP_TRANSACTION = "STP_TRANSACTION";
export const STP_TRANSACTION_SUCCESS = "STP_TRANSACTION_SUCCESS";
export const CANCEL_SIP = "CANCEL_SIP";
export const CANCEL_SIP_SUCCESS = "CANCEL_SIP_SUCCESS";
export const CANCEL_SWP = "CANCEL_SWP";
export const CANCEL_SWP_SUCCESS = "CANCEL_SWP_SUCCESS";
export const CANCEL_STP = "CANCEL_STP";
export const CANCEL_STP_SUCCESS = "CANCEL_STP_SUCCESS";

export const singleTransaction = {
  NEW_PURCHASE_LUMPSUM: "NPL",
  ADDITIONAL_PURCHASE_LUMPSUM: "APL",
  REDEMPTION: "RED",
  SWITCH: "SWITCH",
  STP: "STP",
  SWP: "SWP",
  SIP_REGISTRATION_NEW: "SIPN",
  SIP_REGISTRATION_EXISTING: "SIP",
  SIP_PAUSE: "PAUSE",
  CANCEL_SIP: "SIPC",
  CANCEL_STP: "STPC",
  CANCEL_SWP: "SWPC",
  DCR: "KTRWD",
};
